// components/Button.js
import React from "react";

export default function Button({
  children,
  onClick,
  className = "",
  type = "button",
  loading = false,
  ...props
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`${loading ? "opacity-80" : ""} ${className}`}
      disabled={loading}
      {...props}
    >
      {loading ? (
        <i className="fa-solid fa-spinner animate-spin"></i>
      ) : (
        children
      )}
    </button>
  );
}